export enum DialogOpenStatus {
  FILE_UPLOAD = "File upload",
  DETAIL = "Details",
  CLOSED = "Closed",
}
